import { render } from "./AISalesContent.vue?vue&type=template&id=d6b6f10c&scoped=true"
import script from "./AISalesContent.vue?vue&type=script&lang=js"
export * from "./AISalesContent.vue?vue&type=script&lang=js"

import "./AISalesContent.vue?vue&type=style&index=0&id=d6b6f10c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b6f10c"]])

export default __exports__